import { ARCHIVED_COLUMN, LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Report ID',
    field: 'reportId',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Event Status',
    field: 'status',
    width: LIST_WIDTH.STATUS,
    cellRenderer: 'convertEventStatus',
  },
  {
    headerName: 'Category',
    field: 'categoryName',
    width: LIST_WIDTH.default,
    cellRenderer: 'convertEventCategory',
  },
  {
    headerName: 'Type',
    field: 'type',
    width: LIST_WIDTH.default,
    cellRenderer: 'convertEventType',
  },
  { headerName: 'Title', field: 'title', width: LIST_WIDTH.default },
  {
    headerName: 'Last Updated At',
    field: 'lastUpdatedTime',
    width: LIST_WIDTH.TIME_DATE,
  },
  {
    headerName: 'Creator',
    field: 'creatorName',
    width: LIST_WIDTH.HUMAN_NAME,
    sortable: true,
  },
  {
    headerName: 'Elapsed Time',
    field: 'elapsedTime',
    width: LIST_WIDTH.ELAPSED_NUMBER,
  },
  {
    headerName: 'Published Status',
    field: 'published',
    width: LIST_WIDTH.HUMAN_NAME,
    cellRenderer: 'convertPublishStatus',
  },
  {
    headerName: 'Distribution',
    field: 'distribution',
    width: LIST_WIDTH.default,
    cellRenderer: 'convertDistribution',
  },

  {
    headerName: 'Assignee',
    field: 'assignee',
    width: LIST_WIDTH.HUMAN_NAME,
  },
];
